export default {
  // Initial prompt text
  initialPrompt:
    "Double-click a node to expand related transaction addresses in the selected direction",
  // Multi-select method description
  multiSelectMethod:
    "Multi-select methods: 1. Ctrl/⌘+Left click to select multiple nodes. 2. Right-click and drag to box select multiple nodes",
  // Node type prompts
  node: {
    prompts: [
      "Double-click a node to expand related transaction addresses in the selected direction",
      "Select one or more nodes, click buttons in the top or right operation area to experience more features",
      "Use shortcut (Ctrl+E/⌘+E) or click the expand details button on the left to view node details",
    ],
  },
  // Edge type prompts
  edge: {
    prompts: [
      "Use shortcut (Ctrl+E/⌘+E) or click the expand details button on the left to view transaction details",
    ],
  },
  // Multiple nodes type prompts
  morenode: {
    prompts: [
      "Click buttons in the top or right operation area to experience more features",
      "Press Enter to quickly batch expand address transaction information",
    ],
  },
};
